import { Navigate } from '@tanstack/react-router';

import { usePermissions } from '@/features/auth/hooks/usePermissions';

export function OrganizationSettingsRedirect() {
  const { hasPermission } = usePermissions();
  const canReadDepartmentSettings = hasPermission('hrms:department:read:tenant');
  const canReadTenantSettings =
    hasPermission('tenant:access:read:tenant') || hasPermission('tenant:settings:update:tenant');

  if (canReadDepartmentSettings) {
    return <Navigate to="/settings/organization/profile" replace />;
  }

  if (canReadTenantSettings) {
    return <Navigate to="/settings/organization/regional" replace />;
  }

  return <Navigate to="/settings/organization/teams" replace />;
}
